import { createStore } from "vuex";
import axios from "axios";


const LOCAL_API_URL = "https://marketingvps.lyon-jo.com/api/customers";

const EXTERNAL_API_URL = "https://marketingvps.lyon-jo.com/api/get_customers";
const LOGIN_API_URL = "https://marketingvps.lyon-jo.com/api/login";

export default createStore({
  state: {
    customers: [],
    user: JSON.parse(localStorage.getItem("user")) || null,
    token: localStorage.getItem("token") || null,
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user;
      localStorage.setItem("user", JSON.stringify(user));
    },
    SET_TOKEN(state, token) {
      state.token = token;
      localStorage.setItem("token", token);
    },
    LOGOUT(state) {
      state.user = null;
      state.token = null;
      localStorage.removeItem("user");
      localStorage.removeItem("token");
    },
    SET_CUSTOMERS(state, customersData) {
      state.customers = {
        new_customers: Array.isArray(customersData.new_customers)
          ? customersData.new_customers
          : [],
        our_customers: Array.isArray(customersData.our_customers)
          ? customersData.our_customers
          : [],
        blacklist: Array.isArray(customersData.blacklist)
          ? customersData.blacklist
          : [],
        company_customers: Array.isArray(customersData.company_customers)
          ? customersData.company_customers
          : [],
      };
    },

    ADD_CUSTOMER(state, customer) {
      if (customer.blacklist) {
        state.customers.blacklist.push(customer); // Add to blacklist if blacklisted
      } else if (customer.company) {
        state.customers.company_customers.push(customer); // Add to company_customers if company
      } else if (
        state.customers.our_customers.some((c) => c.id === customer.id)
      ) {
        state.customers.our_customers.push(customer); // Add to our_customers if it exists in the API
      } else {
        state.customers.new_customers.push(customer); // Add to new_customers if it's a new customer
      }
    },

    UPDATE_CUSTOMER(state, { category, updatedCustomer }) {
      const customerIndex = state.customers[category].findIndex(
        (c) => c.id === updatedCustomer.id
      );

      if (customerIndex !== -1) {
        // Update the customer in the correct category
        state.customers[category][customerIndex] = updatedCustomer;
      }
    },
    DELETE_CUSTOMER(state, id) {
      state.customers.new_customers = state.customers.new_customers.filter(
        (c) => c.id !== id
      );
      state.customers.our_customers = state.customers.our_customers.filter(
        (c) => c.id !== id
      );
      state.customers.blacklist = state.customers.blacklist.filter(
        (c) => c.id !== id
      );
      state.customers.company_customers = state.customers.company_customers.filter(
        (c) => c.id !== id
      );
    },
  },
  actions: {
    async loginUser({ commit }, credentials) {
      try {
        const response = await axios.post(LOGIN_API_URL, credentials);
        commit("SET_USER", response.data.user);
        commit("SET_TOKEN", response.data.token);

        axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${response.data.token}`;
      } catch (error) {
        console.error(
          "Login failed:",
          error.response?.data?.message || error.message
        );
        throw error;
      }
    },

    logoutUser({ commit }) {
      commit("LOGOUT");
      delete axios.defaults.headers.common["Authorization"];
    },

    async fetchCustomers({ commit }, { source = "local", search = "" } = {}) {
      try {
        let url = source === "external" ? EXTERNAL_API_URL : LOCAL_API_URL;
        if (search.trim()) {
          url += `?search=${encodeURIComponent(search)}`;
        }
        const response = await axios.get(url);

        let customers = [];

        if (source === "external") {
          customers = response.data.map((customer) => ({
            id: customer.id || null, // Handle missing ID
            name: customer.customer_name || "N/A",
            email: customer.email || "N/A",
            phone: customer.phone || "N/A",
          }));
        } else {
          customers = response.data;
        }
        commit("SET_CUSTOMERS", customers);
      } catch (error) {
        console.error("Error fetching customers:", error);
      }
    },
async addCustomer({ commit }, customerData) {
  try {
    const response = await axios.post(LOCAL_API_URL, customerData, {
      headers: { "Content-Type": "application/json" },
      transformRequest: [(data) => JSON.stringify(data)], // يمنع أي تحويل خارجي
    });

    if (response.status === 200 && response.data.customer) {
      commit("ADD_CUSTOMER", response.data.customer);
      return { success: true, message: response.data.message || "Customer added successfully!" };
    }

    return { success: false, message: response.data.message || "An error occurred." };
  } catch (error) {
    return { success: false, message: error.response?.data?.message || "Failed to add customer." };
  }
},

async updateCustomer({ commit, state }, { id, customerData }) {
  try {
    const response = await axios.put(`${LOCAL_API_URL}/${id}`, customerData, {
      headers: { "Content-Type": "application/json" },
      transformRequest: [(data) => JSON.stringify(data)],
    });

    if (response.data.customer) {
      const updatedCustomer = response.data.customer;
      let category = null;

      if (state.customers.new_customers.some((c) => c.id === id)) category = "new_customers";
      else if (state.customers.our_customers.some((c) => c.id === id)) category = "our_customers";
      else if (state.customers.blacklist.some((c) => c.id === id)) category = "blacklist";
      else if (state.customers.company_customers.some((c) => c.id === id)) category = "company_customers";

      if (category) commit("UPDATE_CUSTOMER", { category, updatedCustomer });
    }
  } catch (error) {
    console.error("Error updating customer:", error.response ? error.response.data : error.message);
    alert("Failed to update customer. Please check your input and try again.");
  }
},

    async deleteCustomer({ commit }, id) {
      await axios.delete(`${LOCAL_API_URL}/${id}`);
      commit("DELETE_CUSTOMER", id);
    },
  },
  getters: {
    isAuthenticated: (state) => !!state.token,
    getUser: (state) => state.user,
  },
});
